import { render, staticRenderFns } from "./PriceControlDetail.vue?vue&type=template&id=ba3c2a0a&scoped=true"
import script from "./PriceControlDetail.vue?vue&type=script&lang=js"
export * from "./PriceControlDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceControlDetail.vue?vue&type=style&index=0&id=ba3c2a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3c2a0a",
  null
  
)

export default component.exports